import React from 'react';
import Services from './../services/services';
import Breadcrumb from './../basics/Breadcrumb';

import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

const Success = () => {

  return (
    <div className="container">
      <div className="d-flex flex-column align-items-center my-5 py-5">
          <i className="text-success fs-1 fa-solid fa-circle-check"></i>
          <div className="fs-2">Letenky úspěšně namoupeny</div>
          <div className="">Potvrzení bude zasláno na Váš email</div>
      </div>
    </div>
  );
}

export default Success;
